import { render, staticRenderFns } from "./filterPills.vue?vue&type=template&id=4450b724"
import script from "./filterPills.vue?vue&type=script&lang=js"
export * from "./filterPills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports